import { SET_OBJ_SOLICITUDES } from "../types";
import IResponseSolicitud from "../../interfaces/IResponseSolicitud";

export const setSolicitud = (payload: IResponseSolicitud) => ({type: SET_OBJ_SOLICITUDES, payload});
